<template>
	<AppBottomSheet :active="active" :forceWidth="bottomSheetWidth" @toggling-popup="open => $emit('toggling-popup', open)" >
		<div class="customers-people-add-container" v-if="active">
			<ModalHeader
				:title="getString('new_customer')"
				:button-text="getString('add')"
				@click-button="addCustomer" />
			<div class="row inputs-containers">
				<div v-if="showButtonExisting" class="wrapper-buttons-add">
					<div class="row-button-add">
						<AppButton icon-left="icon-pointer-hand" small outline :text="getString('existing_customer')" @click="closeBottomSheetPeople" />
					</div>
				</div>
				<div class="row input-container">
					<p>{{ getString('name') }}</p>
					<AppTextInput class="ml-auto" ref="name" :placeholder="getString('name')" />
				</div>
				<div class="row input-container">
					<p>{{ getString('email') }}</p>
					<AppTextInput class="ml-auto" ref="email" :placeholder="getString('email')" type="email" />
				</div>
				<div class="row input-container">
					<p>{{ getString('phone') }}</p>
					<AppTextInput class="ml-auto" ref="phone" :placeholder="getString('phone')" type="phone" />
				</div>
				<div class="row input-container">
					<p>{{ getString('address') }}</p>
					<AppGoogleMapsInput class="text-input ml-auto" :placeholder="getString('address')" no-map @changed-address="(a) => address = a" />
				</div>
				<div class="row input-container">
					<p>{{ getString('fiscal_code') }}</p>
					<AppTextInput class="ml-auto" ref="fiscal" :placeholder="getString('fiscal_code')" />
				</div>
				<div class="row input-container">
					<p>{{ getString('marketing_consent') }}</p>
					<AppSwitch class="ml-auto" ref="privacy" :checked="false" />
				</div>
				<div class="row input-container">
					<p>{{ getString('birth_date') }}</p>
					<DatePicker ref="date-picker" v-model="date" mode="date" color="teal" :max-date='tenYearsAgo' :is-dark="userStore.darkMode">
						<template #default="{ togglePopover }">
							<AppTextInput class="text-input ml-auto" @click="togglePopover()" readonly :placeholder="getString('birth_date')" :value="date ? formatDateYYMMDD(date) : null" />
						</template>
					</DatePicker>
				</div>
				<div class="row input-container">
					<p>{{ getString('gender') }}</p>
					<AppRadioButtonGroup class="ml-auto" ref="gender" allow-no-selection :values="[getString('male'), getString('female'), getString('other')]" />
				</div>
				<div class="row input-container">
					<p>{{ getString('notes') }}</p>
					<AppTextInput class="ml-auto" ref="notes" textarea :placeholder="getString('notes')" />
				</div>
			</div>
		</div>
	</AppBottomSheet>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useCustomersStore, useUserStore} from "@/console-new/stores";
import AppSelect from "@/shared/components/AppSelect.vue";
import {DatePicker} from "v-calendar";
import AppGoogleMapsInput from "@/shared/components/AppGoogleMapsInput.vue";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import {validateEmail, validatePhone} from "@/shared/helpers/strings";
import {formatDateTime, formatDateYYMMDD} from "@/shared/helpers/dates";
import API from "@/shared/helpers/API";
import AppButton from "@/shared/components/AppButton.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		const customersStore = useCustomersStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, customersStore, formatDateYYMMDD, formatDateTime}
	},
	name: "CustomersPeopleAdd",
	components: {AppSwitch, AppButton, AppRadioButtonGroup, AppGoogleMapsInput, AppSelect, ModalHeader, AppBottomSheet, AppTextInput},
	mixins: [WindowWidth],
	emits: ['toggling-popup', 'added-customer', 'close'],
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		showButtonExisting: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			tenYearsAgo: new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
			date: null,
			address: null,
		}
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
	},
	methods: {
		addCustomer() {

			let name = this.$refs['name'].currentValue;
			if(!name || name.length <= 2) {
				this.showNotification("name-required");
				return;
			}

			let email = this.$refs['email'].currentValue;
			email = email && email.length > 0 ? email : null;
			if(email && !validateEmail(email)) {
				this.showNotification("wrong-email");
				return;
			}

			let phone = this.$refs['phone'].currentValue;
			phone = phone && phone.length > 0 ? phone : null;
			if(phone && !validatePhone(phone)) {
				this.showNotification("wrong-phone");
				return;
			}

			let fiscal = this.$refs['fiscal'].currentValue;
			fiscal = fiscal && fiscal.length > 0 ? fiscal : null;
			if(fiscal && fiscal.length < 11) {
				this.showNotification("wrong-fiscal");
				return;
			}

			let genderIndex = this.$refs['gender'].currentSelection;
			let gender = null;
			if(genderIndex === 0) {
				gender = 'male';
			} else if(genderIndex === 1) {
				gender = 'female';
			} else {
				gender = 'other';
			}

			let notes = this.$refs['notes'].currentValue;
			notes = notes && notes.length > 0 ? notes : null;

			let birthDate = this.date ? this.formatDateTime(this.date, false) : null;

			let privacy = this.$refs['privacy'].isChecked;

			API.init().addCustomerPerson(this.userStore.currBusinessId, null, name, email, phone, fiscal, gender, birthDate, JSON.stringify(this.address), notes, privacy, (response) => {
				if(response && response.result && response.result === 'OK' && response.customer) {
					this.showNotification("generic-success");
					this.date = null;
					this.address = null;
					this.$emit('added-customer', response.customer);
				} else {
					this.showNotification("generic-fail");
				}
			});

		},
		closeBottomSheetPeople() {
			this.$emit('close');
		},
	}
}
</script>

<style scoped lang="scss">
.inputs-containers {
	display: flex;
	flex-direction: column;
	align-items: flex-end;

	.input-container {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		justify-content: space-between;
		align-items: center;
		position: relative;
		padding: 8px 12px;

		.ml-auto {
			margin-left: auto;
		}

		&:after {
			content: "";
			position: absolute;
			top: 100%;
			left: 0;
			height: 1px;
			width: 100%;
			background-color: var(--color-alpha-3);
		}

		&:last-child {
			&:after {
				display: none;
			}
		}
	}
}
.wrapper-buttons-add {
	height: 100%;
	width: 100%;
	margin-bottom: 10px;
	.row-button-add {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
	.base-button {
		height: 38px;
		width: 100%;
		max-width: unset;
		background-color: var(--color-bg-primary-2);
		border: none;
		&:hover {
			box-shadow: none;
		}
	}
}
</style>